/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { subscribe } from 'alfa';
import { Col, message, Row, Typography } from 'antd';
import { withTranslation } from 'react-i18next';

import AccountList from '../account/components/list';
import ManagerList from '../manager/components/list';
import AccountRepo from '../../repository/account';
import ManagerRepo from '../../repository/manager';

const BusinessIndex = withTranslation()((props) => {
  const { business, t } = props;
  const [accountLoading, setAccountLoading] = useState(true);
  const [managerLoading, setManagerLoading] = useState(true);
  const [accounts, setAccounts] = useState([]);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    const fetchCollectionInEffect = async () => {
      try {
        const { data: { accounts: accountsFetched } } = await AccountRepo.fetchCollection(business);
        setAccounts(accountsFetched);
      } catch (error) {
        console.error('ERROR: BusinessIndex: AccountRepo.fetchCollection()', error);
        message.error(t('error.loading_accounts'));
      } finally {
        setAccountLoading(false);
      }

      try {
        const { data: { managers: managersFetched } } = await ManagerRepo.fetchCollection(business);
        setManagers(managersFetched.filter((manager) => !manager.disabled_at));
      } catch (error) {
        console.error('ERROR: BusinessIndex: ManagerRepo.fetchCollection()', error);
        message.error(t('error.loading_managers'));
      } finally {
        setManagerLoading(false);
      }
    };
    fetchCollectionInEffect();
  }, [business, t]);

  return (
    <Row gutter={10}>
      <Col xs={24} sm={12} md={12} lg={12} xl={12}>
        <Typography.Title level={3}>{t('accounts')}</Typography.Title>
        <AccountList loading={accountLoading} accounts={accounts} />
      </Col>
      <Col xs={24} sm={12} md={12} lg={12} xl={12}>
        <Typography.Title level={3}>{t('managers')}</Typography.Title>
        <ManagerList compact loading={managerLoading} managers={managers} />
      </Col>
    </Row>
  );
});

export default subscribe(BusinessIndex, ['business']);
